define.alias("shared/components/shared/social/basic-display-deprecation/modal", "settings/components/shared/social/basic-display-deprecation/modal");